import apiEndPoints from "../../../routeConfig";
import { ApiService } from "../../../../service/api.service";

const apiService = new ApiService();

export const getAllUserManagement = async (page = 0, limit = 10) => {
  try {
    const response = await apiService.get(`${apiEndPoints.getAllUserManagement}?page=${page + 1}&limit=${limit}`,);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const userManagementGetById = async (id) => {
  let result;
  await apiService.get(`${apiEndPoints.userManagementGetById}/${id}`)
    .then((response) => {
      result = response.data;
    })
    .catch(error => {
      result = error;
    });
  return result;
};

export const userPatchApi = async (data) => {
  try {
    const response = await apiService.patch(`${apiEndPoints.userPatchApi}`, data);
    return response;
  } catch (error) {
    return error;
  }
};
